import { logWrapper } from '../../utils';

export default {
  documentsPagingService: [
    'revisionService',
    'runtimeConstant',
    function (
      revisionService,
      runtimeConstant
    ) {

      let page = 1;
      let pageSize = 100;
      let total = 0;
      let items = [];
      let loading = false;

      function reset() {
        page = 1;
        total = 0;
        items = [];
      }

      function load(folderId) {
        if (loading)
          return $q.resolve({ items, total });

        loading = true;

        return revisionService
          .loadRevisionsPaged(folderId, page, pageSize)
          .then(res => {
            total = res.total;
            items = items.concat(res.items);
            return { items, total };
          })
          .finally(() => {
            loading = false;
          });
      }

      function incrementPage() {
        page++;
        return page;
      }

      function hasMore() {
        return items.length < total;
      }

      function run() {
        try {
          var documentsPagingServiceFactory = {};

          documentsPagingServiceFactory.reset = logWrapper(
            reset,
            runtimeConstant.isDebugServicesInternals
          );
          documentsPagingServiceFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          documentsPagingServiceFactory.incrementPage = logWrapper(
            incrementPage,
            runtimeConstant.isDebugServicesInternals
          );
          documentsPagingServiceFactory.hasMore = logWrapper(
            hasMore,
            runtimeConstant.isDebugServicesInternals
          );

          return documentsPagingServiceFactory;
        }
        catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ]
};
